import { render, staticRenderFns } from "./interventionsButton.vue?vue&type=template&id=d24a9a4c"
import script from "./interventionsButton.vue?vue&type=script&lang=js"
export * from "./interventionsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports